import React, { useEffect, useState, useCallback, useRef } from "react";
import {
  PaymentVoucherUpdate,
  PaymentVoucherCreate,
  GetApproveGVs,
  GetApprovedPVs,
  BankDetailList,
  GeneratePaymentVoucherNo,
  ApproveExpenseList,
  DivisionList,
  LedgerName,
  ApproveSolistapi,
  fetchJournalVouchersBySupplier,
  fetchJournalVouchersByImprest,
  fetchPurchaseVouchersBySupplier,
  fetchJournalVouchersByAdvanceWorker,
} from "../../../Services/Services";
import {
  Box,
  TextField,
  Grid,
  Typography,
  Card,
  CardContent,
  Divider,
  Autocomplete,
  CircularProgress,
  useMediaQuery,
  useTheme,
  IconButton,
  Tooltip,
  Modal,

  Button
} from "@mui/material";

import Close from "@mui/icons-material/Close";  // ✅ ADD THI
import { toast, ToastContainer } from "react-toastify";
import { debounce } from "lodash";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useLocation } from "react-router";

// Imports me ye add karo (agar nahi hai)
import DownloadIcon from "@mui/icons-material/Download";
import PrintIcon from "@mui/icons-material/Print";

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import { ToWords } from "to-words";
pdfMake.vfs = pdfFonts.vfs;

const toWords = new ToWords();

const NeftRtgsPaymentForm = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const location = useLocation();
  const isEditMode = location.state?.editMode || false;
  const editData = location.state?.voucherData || null;

  const navigate = useNavigate();

  // Print preview state for mobile
  const [showPrintPreview, setShowPrintPreview] = useState(false);
  const [previewPdfUrl, setPreviewPdfUrl] = useState(null);

  // ✅ SINGLE ENTRY STATE
  const [paymentVoucherNo, setPaymentVoucherNo] = useState("");
  const [paymentNumber, setPaymentNumber] = useState("");
  const [party, setParty] = useState(null);
  const [partyName, setPartyName] = useState("");
  const [project, setProject] = useState("");
  const [projectName, setProjectName] = useState("");
  const [supplier, setSupplier] = useState(null);
  const [supplierName, setSupplierName] = useState("");
  const [imprestAccount, setImprestAccount] = useState(null);
  const [imprestAccountName, setImprestAccountName] = useState("");
  const [advanceWorker, setAdvanceWorker] = useState(null);
  const [advanceWorkerName, setAdvanceWorkerName] = useState("");
  const [ledgerType, setLedgerType] = useState("");
  const [division, setDivision] = useState("");
  const [divisionName, setDivisionName] = useState("");
  const [chequeDate, setChequeDate] = useState("");
  const [paymentDate, setPaymentDate] = useState("");
  const [methodOfPayment, setMethodOfPayment] = useState("");
  const [voucherType, setVoucherType] = useState("");
  const [transporter, setTransporter] = useState(null);
  const [transporterName, setTransporterName] = useState("");
  const [totalAmount, setTotalAmount] = useState("");
  const [againstReferenceAmount, setAgainstReferenceAmount] = useState("");
  const [paymentMode, setPaymentMode] = useState("");
  const [description, setDescription] = useState("");
  const [recommended_by, setRecommendedBy] = useState("");
  const [bank, setBank] = useState("");
  const [invoiceDate, setInvoiceDate] = useState("");
  const [attachment, setAttachment] = useState(null);
  const [narration, setNarration] = useState("");
  const [expense, setExpense] = useState(null); // ✅ EXPENSE STATE
  const [expenseName, setExpenseName] = useState(""); // ✅ EXPENSE NAME STATE
  const [selectedBank, setSelectedBank] = useState(null);

  // ✅ NEW STATE FOR NEFT/RTGS CHECKBOX & DETAILS
  const [showNeftRtgsDetails, setShowNeftRtgsDetails] = useState(true);
  const [neftRtgsAccountNumber, setNeftRtgsAccountNumber] = useState("");
  const [neftRtgsIfscCode, setNeftRtgsIfscCode] = useState("");
  const [neftRtgsBankName, setNeftRtgsBankName] = useState("");
  const [neftRtgsBranchName, setNeftRtgsBranchName] = useState("");
  const [NeftRtgsName, setNeftRtgsName] = useState("");
  const [NeftRtgsaddress, setNeftRtgsaddress] = useState("");
  const [NeftRtgscontact, setNeftRtgscontact] = useState("");
  const [NeftRtgsAccountType, setNeftRtgsAccountType] = useState("");
  // Component ke andar, jahan baaki useState hain, wahan ye add karo:

  const [bankNameOf, setBankNameOf] = useState("");
  const [branchAddress, setBranchAddress] = useState("");
  const [beneficiaryAddressInput, setBeneficiaryAddressInput] = useState("");

  // ✅ Add this state at the top with other states
  const [isNeftRtgs, setIsNeftRtgs] = useState(true);

  const [formErrors, setFormErrors] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [currentEditId, setCurrentEditId] = useState(null);
  const [submitLoading, setSubmitLoading] = useState(false);

  const [existingFileName, setExistingFileName] = useState("");

  const [expenseRows, setExpenseRows] = useState([{ expense: "", amount: "" }]);
  const [expenses, setExpenses] = useState([]);
  const [purchaseVouchers, setPurchaseVouchers] = useState([]);
  const [journalVouchers, setJournalVouchers] = useState([]);
  const [allJournalVouchers, setAllJournalVouchers] = useState([]);
  const [allPurchaseVouchers, setAllPurchaseVouchers] = useState([]);
  const [selectedVouchers, setSelectedVouchers] = useState([]);
  const [projectLists, setProjectLists] = useState([]);
  const [ledgers, setLedgers] = useState([]);
  const [bankDetails, setBankDetails] = useState([]);
  const [divisionLists, setDivisionLists] = useState([]);
  const [transporters, setTransporters] = useState([]);
  const [ledgerOptions, setLedgerOptions] = useState([]);
  const [ledgerLoading, setLedgerLoading] = useState(false);
  const [ledgerInputValue, setLedgerInputValue] = useState("");
  const [selectedLedger, setSelectedLedger] = useState(null);
  const [chequeNo, setChequeNo] = useState("");

  // ✅ CACHE MECHANISM
  const ledgerCache = useRef(new Map());
  // ✅ Get current date for PDF in DD/MM/YYYY format
  const getCurrentDateForPdf = () => {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const year = today.getFullYear();
    return `${day}/${month}/${year}`;
  };
  // ✅ OPTIMIZED LEDGER SEARCH WITH CACHE
  const fetchLedgersWithSearch = async (searchText = "") => {
    const cacheKey = searchText.toLowerCase();
    if (ledgerCache.current.has(cacheKey)) {
      setLedgerOptions(ledgerCache.current.get(cacheKey));
      setLedgerLoading(false);
      return;
    }

    setLedgerLoading(true);
    try {
      const response = await LedgerName({ search: searchText });

      let data = [];
      if (response?.results?.data) {
        data = response.results.data;
      } else if (response?.data) {
        data = response.data;
      } else if (Array.isArray(response)) {
        data = response;
      }

      ledgerCache.current.set(cacheKey, data);
      setLedgerOptions(data);
      setLedgers(data);
    } catch (error) {
      setLedgerOptions([]);
    } finally {
      setLedgerLoading(false);
    }
  };

  // ✅ DEBOUNCED SEARCH FUNCTION
  const debouncedLedgerSearch = useCallback(
    debounce((searchText) => {
      if (searchText.trim().length >= 2) {
        fetchLedgersWithSearch(searchText);
      } else if (searchText.trim().length === 0) {
        fetchLedgersWithSearch("");
      }
    }, 500),
    []
  );

  // --------- HELPERS FOR CHALLAN FIELDS ---------
  const senderName = "K P & GRANDSONS";
  const senderAddress = "K-5,DHEBUR STEEL CITY, AVANTI VIHAR";
  const senderContactNo = "9302122967";
  const senderEmail = "kpgrandsons@rediffmail.com";

  const beneficiaryName = NeftRtgsName || "";
  const senderMobile = ""; // अभी blank
  const senderAccountType = ""; // जैसे 'CC', 'C/A' आदि
  // const senderAccountNo = "";
  const senderAccountNo = selectedBank?.account_number || "";
  // const chequeNo = ""; // फिलहाल blank, बाद में state बना सकते हो
  const neftCharges = ""; // अगर charges होंगे तो add कर लेना

  const beneficiaryBankName =
    neftRtgsBankName ||
    // bankDetails.find((b) => b.id === bank)?.bank_name ||
    "";

  const beneficiaryBranch = neftRtgsBranchName || "";
  const beneficiaryBranchAddress = ""; // फिलहाल blank
  const beneficiaryAccountType = ""; // जैसे 'C/A'
  const beneficiaryAccountNo = neftRtgsAccountNumber || "";
  const beneficiaryAddress = NeftRtgsaddress || "";
  const beneficiaryContactNo = NeftRtgscontact || "";

  const amountNumber = parseFloat(totalAmount || 0) || 0;
  const amountInWords =
    amountNumber > 0
      ? toWords.convert(amountNumber).toUpperCase() + " ONLY"
      : "";



  const handlePdfDownload = () => {
    // FULL BORDER ALWAYS
    const fullBorderLayout = {
      hLineWidth: () => 0.5,
      vLineWidth: () => 0.5,
      hLineColor: () => "#000",
      vLineColor: () => "#000",
      paddingLeft: () => 1.5,
      paddingRight: () => 1.5,
      paddingTop: () => 0.5,
      paddingBottom: () => 0.5,
    };

    // Helper for uniform rows
    const row = (label, value) => [
      { text: label || "", fontSize: 8, alignment: "left" },
      { text: value || "", fontSize: 8, alignment: "left" },
    ];

    // ✅ NEW: Helper for 4-column row (mobile + email ek line me)
    const row4Col = (label1, value1, label2, value2) => [
      { text: label1 || "", fontSize: 8, colSpan: 1 },
      { text: value1 || "", fontSize: 8, colSpan: 1 },
      { text: label2 || "", fontSize: 8, colSpan: 1 },
      { text: value2 || "", fontSize: 8, colSpan: 1 },
    ];

    const fullRow = (text, bold = false) => [
      {
        text,
        bold,
        fontSize: bold ? 9 : 8,
        alignment: "left",
        colSpan: 2,
      },
      {},
    ];

    // ================= CHALLAN GENERATOR =================
    const createChallan = (copyType) => {
      const currentDate = getCurrentDateForPdf();
      return [
        // Title
        {
          table: {
            widths: ["100%"],
            body: [
              [
                {
                  text: "INDIAN OVERSEAS BANK, RAIPUR",
                  bold: true,
                  alignment: "center",
                  fontSize: 9,
                },
              ],
              [
                {
                  text: `NEFT REMITTANCE CHALLAN ${copyType}`,
                  bold: true,
                  alignment: "center",
                  fontSize: 8,
                },
              ],
            ],
          },
          layout: fullBorderLayout,
          margin: [0, 0, 0, 2],
        },

        // A) Sender - ✅ YE TABLE UPDATE KIYA
        {
          table: {
            widths: ["18%", "32%", "18%", "32%"], // 4 columns
            body: [
              // Header
              [
                {
                  text: "A) Particulars of Sender",
                  bold: true,
                  fontSize: 9,
                  alignment: "left",
                  colSpan: 4,
                },
                {},
                {},
                {},
              ],
              // Name row (spanning all 4 columns)
              [
                { text: "1 Name :-", fontSize: 8 },
                { text: senderName, fontSize: 8, colSpan: 3 },
                {},
                {},
              ],
              // Address row (spanning all 4 columns)
              [
                { text: "2 Address :-", fontSize: 8 },
                { text: senderAddress, fontSize: 8, colSpan: 3 },
                {},
                {},
              ],
              // Phone row (spanning all 4 columns)
              [
                { text: "3 Phone :-", fontSize: 8 },
                { text: senderContactNo, fontSize: 8, colSpan: 3 },
                {},
                {},
              ],
              // ✅ Mobile + Email ek line me
              [
                { text: "Mobile :-", fontSize: 8 },
                { text: senderMobile, fontSize: 8 },
                { text: "Email :-", fontSize: 8 },
                { text: senderEmail, fontSize: 7 }, // thoda small font for email
              ],
              // Account type row
              [
                { text: "4 Type of Account", fontSize: 8 },
                { text: senderAccountType, fontSize: 8 },
                { text: "A/c No.", fontSize: 8 },
                { text: senderAccountNo, fontSize: 8 },
              ],
              // Amount row
              [
                { text: "5 Amount to be remitted", fontSize: 8 },
                {
                  text: `Rs. ${amountNumber.toFixed(2)}`,
                  fontSize: 8,
                  colSpan: 3,
                },
                {},
                {},
              ],
              // Amount in words
              [
                {
                  text: `(Rs. ${amountInWords})`,
                  fontSize: 8,
                  alignment: "left",
                  colSpan: 4,
                },
                {},
                {},
                {},
              ],
            ],
          },
          layout: fullBorderLayout,
          margin: [0, 0, 0, 2],
        },

        // Amount Table
        {
          table: {
            widths: ["50%", "50%"],
            body: [
              row("6 Amount of Remittance", `Rs. ${amountNumber.toFixed(2)}`),
              row("Charges", `Rs. ${neftCharges || "0.00"}`),
              row(
                "Total",
                `Rs. ${(amountNumber + Number(neftCharges || 0)).toFixed(2)}`
              ),
            ],
          },
          layout: fullBorderLayout,
          margin: [0, 0, 0, 2],
        },

        // Cheque
        {
          table: {
            widths: ["50%", "50%"],
            body: [
              row("7 Cheque no.", chequeNo),
              fullRow("Debit my account-"),
              fullRow(`(Rs. ${amountInWords})`),
            ],
          },
          layout: fullBorderLayout,
          margin: [0, 0, 0, 2],
        },

        // Beneficiary
        {
          table: {
            widths: ["35%", "65%"],
            body: [
              fullRow("8 Particulars of Beneficiary", true),
              row("1 IFSC Code:", neftRtgsIfscCode),
              row("2 Account with Bank", neftRtgsBankName),
              row("Name of Bank", bankNameOf),
              row("Branch", neftRtgsBranchName),
              row("3 Branch Address", branchAddress),
              row("4 Type of Account", NeftRtgsAccountType),
              row("5 Account No.", neftRtgsAccountNumber),
              row("6 Beneficiary Name", NeftRtgsName),
              row("7 Beneficiary Address", beneficiaryAddressInput),

              row("8 Beneficiary Contact", NeftRtgscontact),
              row("9 Date", currentDate),
            ],
          },
          layout: fullBorderLayout,
          margin: [0, 0, 0, 2],
        },

        // Signatures
        {
          table: {
            widths: ["33%", "33%", "34%"],
            body: [
              [
                { text: "Applicant's Signatures", fontSize: 8 },
                { text: "Branch Seal", fontSize: 8 },
                { text: "Authorised Signatory", fontSize: 8 },
              ],
              [
                { text: " ", margin: [0, 10, 0, 0] }, // reduced height
                { text: " ", margin: [0, 10, 0, 0] },
                { text: " ", margin: [0, 10, 0, 0] },
              ],
            ],
          },
          layout: fullBorderLayout,
          margin: [0, 0, 0, 2],
        },

        // Footer
        {
          table: {
            widths: ["35%", "65%"],
            body: [
              row("NEFT UTR NO.", ""),
              row("Received for remittance through NEFT", ""),
              row("Date", currentDate), // ✅ ADD THIS LINE
            ],
          },
          layout: fullBorderLayout,
          margin: [0, 0, 0, 2],
        },

        // Note
        {
          table: {
            widths: ["100%"],
            body: [
              [
                {
                  text: "** The Remittance Facility to a Bank other than Nepal SBI Bank Ltd., will be operational after RBI's notification",
                  fontSize: 7,
                },
              ],
            ],
          },
          layout: fullBorderLayout,
        },
      ];
    };

    // ================= PDF DEFINITION =================
    const docDefinition = {
      pageSize: "A4",
      pageOrientation: "landscape",
      pageMargins: [40, 15, 40, 15],
      content: [
        {
          columns: [
            { width: "46%", stack: createChallan("BRANCH COPY") },
            { width: "8%", text: "" },
            { width: "46%", stack: createChallan("CUSTOMER COPY") },
          ],
        },
      ],
    };

    pdfMake
      .createPdf(docDefinition)
      .download(`NEFT_Challan_${paymentNumber || "payment"}.pdf`);
  };
  const handlePrint = () => {
    // FULL BORDER - REDUCED PADDING
    const fullBorderLayout = {
      hLineWidth: () => 0.5,
      vLineWidth: () => 0.5,
      hLineColor: () => "#000",
      vLineColor: () => "#000",
      paddingLeft: () => 1.5,
      paddingRight: () => 1.5,
      paddingTop: () => 0.5,
      paddingBottom: () => 0.5,
    };

    const row = (label, value) => [
      { text: label || "", fontSize: 8, alignment: "left" },
      { text: value || "", fontSize: 8, alignment: "left" },
    ];

    const fullRow = (text, bold = false) => [
      {
        text,
        bold,
        fontSize: bold ? 9 : 8,
        alignment: "left",
        colSpan: 2,
      },
      {},
    ];

    const currentDate = getCurrentDateForPdf();

    const createChallan = (copyType) => {
      return [
        {
          table: {
            widths: ["100%"],
            body: [
              [
                {
                  text: "INDIAN OVERSEAS BANK, RAIPUR",
                  bold: true,
                  alignment: "center",
                  fontSize: 9,
                },
              ],
              [
                {
                  text: `NEFT REMITTANCE CHALLAN ${copyType}`,
                  bold: true,
                  alignment: "center",
                  fontSize: 8,
                },
              ],
            ],
          },
          layout: fullBorderLayout,
          margin: [0, 0, 0, 1],
        },

        {
          table: {
            widths: ["22%", "28%", "22%", "28%"],
            body: [
              [
                {
                  text: "A) Particulars of Sender",
                  bold: true,
                  fontSize: 9,
                  alignment: "left",
                  colSpan: 4,
                },
                {},
                {},
                {},
              ],
              [
                { text: "1 Name :-", fontSize: 8, alignment: "left" },
                { text: senderName, fontSize: 8, alignment: "left", colSpan: 3 },
                {},
                {},
              ],
              [
                { text: "2 Address :-", fontSize: 8, alignment: "left" },
                { text: senderAddress, fontSize: 8, alignment: "left", colSpan: 3 },
                {},
                {},
              ],
              [
                { text: "3 Phone :-", fontSize: 8, alignment: "left" },
                { text: senderContactNo, fontSize: 8, alignment: "left", colSpan: 3 },
                {},
                {},
              ],
              [
                { text: "Mobile :-", fontSize: 8, alignment: "left" },
                { text: senderMobile, fontSize: 8, alignment: "left" },
                { text: "Email :-", fontSize: 8, alignment: "left" },
                { text: senderEmail, fontSize: 7, alignment: "left" },
              ],
              [
                { text: "4 Type of Account", fontSize: 8, alignment: "left" },
                { text: senderAccountType, fontSize: 8, alignment: "left" },
                { text: "A/c No.", fontSize: 8, alignment: "left" },
                { text: senderAccountNo, fontSize: 8, alignment: "left" },
              ],
              [
                { text: "5 Amount to be remitted", fontSize: 8, alignment: "left" },
                {
                  text: `Rs. ${amountNumber.toFixed(2)}`,
                  fontSize: 8,
                  alignment: "left",
                  colSpan: 3,
                },
                {},
                {},
              ],
              [
                {
                  text: `(Rs. ${amountInWords})`,
                  fontSize: 8,
                  alignment: "left",
                  colSpan: 4,
                },
                {},
                {},
                {},
              ],
            ],
          },
          layout: fullBorderLayout,
          margin: [0, 0, 0, 1],
        },

        {
          table: {
            widths: ["50%", "50%"],
            body: [
              row("6 Amount of Remittance", `Rs. ${amountNumber.toFixed(2)}`),
              row("Charges", `Rs. ${neftCharges || "0.00"}`),
              row("Total", `Rs. ${(amountNumber + Number(neftCharges || 0)).toFixed(2)}`),
            ],
          },
          layout: fullBorderLayout,
          margin: [0, 0, 0, 1],
        },

        {
          table: {
            widths: ["50%", "50%"],
            body: [
              row("7 Cheque no.", chequeNo),
              fullRow("Debit my account-"),
              fullRow(`(Rs. ${amountInWords})`),
            ],
          },
          layout: fullBorderLayout,
          margin: [0, 0, 0, 1],
        },

        {
          table: {
            widths: ["40%", "60%"],
            body: [
              [
                {
                  text: "8 Particulars of Beneficiary",
                  bold: true,
                  fontSize: 9,
                  alignment: "left",
                  colSpan: 2,
                },
                {},
              ],
              row("1 IFSC Code:", neftRtgsIfscCode),
              row("2 Account with Bank", neftRtgsBankName),
              row("Name of Bank", bankNameOf),
              row("Branch", neftRtgsBranchName),
              row("3 Branch Address", branchAddress),
              row("4 Type of Account", NeftRtgsAccountType),
              row("5 Account No.", neftRtgsAccountNumber),
              row("6 Beneficiary Name", NeftRtgsName),
              row("7 Beneficiary Address", beneficiaryAddressInput),
              row("8 Beneficiary Contact", NeftRtgscontact),
              row("9 Date", currentDate),
            ],
          },
          layout: fullBorderLayout,
          margin: [0, 0, 0, 1],
        },

        {
          table: {
            widths: ["33%", "33%", "34%"],
            body: [
              [
                { text: "Applicant's Signatures", fontSize: 8, alignment: "left" },
                { text: "Branch Seal", fontSize: 8, alignment: "left" },
                { text: "Authorised Signatory", fontSize: 8, alignment: "left" },
              ],
              [
                { text: " ", margin: [0, 3, 0, 0] },
                { text: " ", margin: [0, 3, 0, 0] },
                { text: " ", margin: [0, 3, 0, 0] },
              ],
            ],
          },
          layout: fullBorderLayout,
          margin: [0, 0, 0, 1],
        },

        {
          table: {
            widths: ["40%", "60%"],
            body: [
              row("NEFT UTR NO.", ""),
              row("Received for remittance through NEFT", ""),
              row("Date", currentDate),
            ],
          },
          layout: fullBorderLayout,
          margin: [0, 0, 0, 1],
        },

        {
          table: {
            widths: ["100%"],
            body: [
              [
                {
                  text: "** The Remittance Facility to a Bank other than Nepal SBI Bank Ltd., will be operational after RBI's notification",
                  fontSize: 7,
                  alignment: "left",
                },
              ],
            ],
          },
          layout: fullBorderLayout,
        },
      ];
    };

    const docDefinition = {
      pageSize: "A4",
      pageOrientation: "landscape",
      pageMargins: [10, 15, 10, 15],
      content: [
        {
          columns: [
            {
              width: "48%",
              stack: createChallan("BRANCH COPY"),
            },
            {
              width: "4%",
              text: "",
            },
            {
              width: "48%",
              stack: createChallan("CUSTOMER COPY"),
            },
          ],
        },
      ],
    };

    // ✅ MOBILE: Preview with Download, DESKTOP: Direct Print
    if (isMobile) {
      pdfMake.createPdf(docDefinition).getDataUrl((dataUrl) => {
        setPreviewPdfUrl(dataUrl);
        setShowPrintPreview(true);
      });
    } else {
      // Desktop: Direct Print
      pdfMake.createPdf(docDefinition).getBlob((blob) => {
        const blobUrl = URL.createObjectURL(blob);
        const printFrame = document.createElement("iframe");
        printFrame.style.position = "fixed";
        printFrame.style.right = "0";
        printFrame.style.bottom = "0";
        printFrame.style.width = "0";
        printFrame.style.height = "0";
        printFrame.style.border = "0";
        printFrame.src = blobUrl;

        document.body.appendChild(printFrame);

        printFrame.onload = () => {
          setTimeout(() => {
            printFrame.contentWindow.focus();
            printFrame.contentWindow.print();
            setTimeout(() => {
              document.body.removeChild(printFrame);
              URL.revokeObjectURL(blobUrl);
            }, 60000);
          }, 250);
        };
      });
    }
  };
  const handleLedgerChange = (ledger) => {
    // ledger may be null when cleared
    setSelectedLedger(ledger); // store it so other handlers can use it

    // clear ledger related errors
    setFormErrors((prev) => {
      const updated = { ...prev };
      delete updated.ledger;
      return updated;
    });

    if (ledger) {
      // Reset other fields
      setParty(null);
      setPartyName("");
      setSupplier(null);
      setSupplierName("");
      setImprestAccount(null);
      setImprestAccountName("");
      setAdvanceWorker(null);
      setAdvanceWorkerName("");
      setTransporter(null);
      setTransporterName("");
      setExpense(null);
      setExpenseName("");
      setLedgerType(ledger.type);
      setVoucherType("");

      // If ledger has bank details, populate NEFT/RTGS fields (but don't force-show checkbox)
      if (
        ledger.account_no ||
        ledger.ifsc_code ||
        ledger.bank_name ||
        ledger.branch_name ||
        ledger.name ||
        ledger.address
      ) {
        setNeftRtgsAccountNumber(ledger.account_no || "");
        setNeftRtgsIfscCode(ledger.ifsc_code || "");
        setNeftRtgsBankName(ledger.bank_name || "");
        setNeftRtgsBranchName(ledger.branch_name || "");
        setNeftRtgsName(ledger.name || "");
        setNeftRtgsaddress(ledger.address || "");
        setNeftRtgscontact(ledger.contact || "");
        setNeftRtgsAccountType(ledger.account_type || "");

        // optional: you may want to also auto-check/show:
        // setShowNeftRtgsDetails(true); setIsNeftRtgs(true);
      } else {
        // ledger has no bank info -> clear fields
        setNeftRtgsAccountNumber("");
        setNeftRtgsIfscCode("");
        setNeftRtgsBankName("");
        setNeftRtgsBranchName("");
        setNeftRtgsName("");
        setNeftRtgsaddress("");
        setNeftRtgscontact("");
        setNeftRtgsAccountType("");
        // keep checkbox state as-is (don't forcibly hide)
      }

      // set other specific ledger fields
      switch (ledger.type) {
        case "Party":
          setParty(ledger.id);
          setPartyName(ledger.name);
          break;
        case "Supplier":
          setSupplier(ledger.id);
          setSupplierName(ledger.name);
          break;
        case "Imprest":
          setImprestAccount(ledger.id);
          setImprestAccountName(ledger.name);
          break;
        case "AdvanceWorker":
          setAdvanceWorker(ledger.id);
          setAdvanceWorkerName(ledger.name);
          break;
        case "Transporter":
          setTransporter(ledger.id);
          setTransporterName(ledger.name);
          break;
        case "Expense":
          setExpense(ledger.id);
          setExpenseName(ledger.name);
          break;
        default:
          break;
      }
    } else {
      // cleared selection -> reset all ledger-related state
      setParty(null);
      setPartyName("");
      setSupplier(null);
      setSupplierName("");
      setImprestAccount(null);
      setImprestAccountName("");
      setAdvanceWorker(null);
      setAdvanceWorkerName("");
      setTransporter(null);
      setTransporterName("");
      setExpense(null);
      setExpenseName("");
      setLedgerType("");

      // clear NEFT/RTGS details & hide checkbox
      setShowNeftRtgsDetails(true);
      setIsNeftRtgs(true);
      setNeftRtgsAccountNumber("");
      setNeftRtgsIfscCode("");
      setNeftRtgsBankName("");
      setNeftRtgsBranchName("");
    }
  };
  // ✅ SIMPLIFIED PAYMENT METHOD CHANGE HANDLER
  const handlePaymentMethodChange = (methodType) => {
    setFormErrors((prev) => {
      const updated = { ...prev };
      delete updated.method_of_payment;
      return updated;
    });

    setMethodOfPayment(methodType);
    setVoucherType("");
    setTotalAmount("");

    // ✅ Against Reference के लिए automatic voucher type set करें
    if (methodType === "against_reference") {
      if (ledgerType === "Imprest" && imprestAccount) {
        setVoucherType("journal");
        fetchJournalVouchersByImprestAPI(imprestAccount);
      } else if (ledgerType === "AdvanceWorker" && advanceWorker) {
        setVoucherType("journal");
        fetchJournalVouchersByAdvanceWorkerAPI(advanceWorker);
      }
    }
  };

  // ✅ SIMPLIFIED VOUCHER TYPE CHANGE HANDLER
  const handleVoucherTypeChange = (voucherTypeValue) => {
    setVoucherType(voucherTypeValue);

    if (voucherTypeValue !== "expense") {
      setExpenseRows([{ expense: "", amount: "" }]);
    }

    if (voucherTypeValue === "purchase") {
      if (
        ledgerType === "Supplier" &&
        methodOfPayment === "against_reference" &&
        supplier
      ) {
        fetchPurchaseVouchersBySupplierAPI(supplier);
      } else {
        setPurchaseVouchers([...allPurchaseVouchers]);
        setSelectedVouchers([...allPurchaseVouchers]);
      }
    } else if (voucherTypeValue === "journal") {
      if (
        ledgerType === "Supplier" &&
        methodOfPayment === "against_reference" &&
        supplier
      ) {
        fetchJournalVouchersBySupplierAPI(supplier);
      } else if (
        ledgerType === "Imprest" &&
        methodOfPayment === "against_reference" &&
        imprestAccount
      ) {
        fetchJournalVouchersByImprestAPI(imprestAccount);
      }
    } else {
      setSelectedVouchers([]);
    }
  };
  // ✅ Current date in DD/MM/YYYY format
  const getCurrentDate = () => {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const year = today.getFullYear();
    return `${day}/${month}/${year}`;
  };

  // ✅ Current date in YYYY-MM-DD format (for state)
  const getCurrentDateForState = () => {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const year = today.getFullYear();
    return `${year}-${month}-${day}`;
  };
  // ✅ SIMPLIFIED DIVISION CHANGE
  const handleDivisionChange = (selectedDivision) => {
    if (selectedDivision) {
      setDivision(selectedDivision.id);
      setDivisionName(selectedDivision.name);
    } else {
      setDivision("");
      setDivisionName("");
    }
  };

  // ✅ SIMPLIFIED PROJECT CHANGE
  const handleProjectChange = (selectedProject) => {
    if (selectedProject) {
      setProject(selectedProject.id);
      setProjectName(selectedProject.name);
    } else {
      setProject("");
      setProjectName("");
    }
  };

  const handleNeftRtgsCheckboxChange = (event) => {
    const isChecked = event.target.checked;
    setShowNeftRtgsDetails(isChecked);
    setIsNeftRtgs(isChecked);

    if (isChecked && selectedLedger) {
      // ✅ Fill NEFT/RTGS details again from selected ledger if available
      setNeftRtgsAccountNumber(selectedLedger.account_no || "");
      setNeftRtgsIfscCode(selectedLedger.ifsc_code || "");
      setNeftRtgsBankName(selectedLedger.bank_name || "");
      setNeftRtgsBranchName(selectedLedger.branch_name || "");
    } else if (!isChecked) {
      // ✅ Clear fields on uncheck
      setNeftRtgsAccountNumber("");
      setNeftRtgsIfscCode("");
      setNeftRtgsBankName("");
      setNeftRtgsBranchName("");
    }
  };

  const fetchJournalVouchersByAdvanceWorkerAPI = async (advanceWorkerId) => {
    try {
      const response = await fetchJournalVouchersByAdvanceWorker(
        advanceWorkerId
      );
      const jvData = Array.isArray(response)
        ? response
        : response?.results || response?.data || [];

      const filteredJournalVouchers = jvData.map((jv) => ({
        id: jv.gen_voucher_no,
        voucher_no: jv.gen_number || jv.voucher_number,
        bill_no: jv.bill_no,
        total_amount:
          parseFloat(jv.sub_vouchers?.[0]?.amount) ||
          parseFloat(jv.total_amount) ||
          0,
        remaining_amount: parseFloat(jv.balance_amount) || 0,
        paid_amount: "",
        type: "journal",
      }));

      setJournalVouchers(filteredJournalVouchers);
      setSelectedVouchers(filteredJournalVouchers);

      if (filteredJournalVouchers.length === 0) {
        toast.info("No journal vouchers found for this advance worker");
      } else {
        toast.success(
          `Found ${filteredJournalVouchers.length} journal voucher(s)`
        );
      }
    } catch (error) {
      toast.error("Failed to fetch journal vouchers");
    }
  };

  const handleVoucherCheckboxChange = (voucherIndex, isChecked) => {
    setSelectedVouchers((prev) => {
      const updated = [...prev];
      const voucher = updated[voucherIndex];
      if (isChecked) {
        updated[voucherIndex] = {
          ...voucher,
          paid_amount: voucher.remaining_amount.toString(),
        };
        toast.success(
          `₹${voucher.remaining_amount.toFixed(2)} added to adjust amount`
        );
      } else {
        updated[voucherIndex] = {
          ...voucher,
          paid_amount: "",
        };
        toast.info("Adjust amount cleared");
      }
      return updated;
    });
  };

  const getVoucherTypeOptions = (ledgerType) => {
    switch (ledgerType) {
      case "Supplier":
        return [
          { value: "journal", label: "Journal Voucher" },
          { value: "purchase", label: "Purchase Voucher" },
        ];
      case "Imprest":
        return [{ value: "journal", label: "Journal Voucher" }];
      case "AdvanceWorker":
        return [{ value: "journal", label: "Journal Voucher" }];
      default:
        return [];
    }
  };

  const fetchPurchaseVouchersBySupplierAPI = async (supplierId) => {
    try {
      const response = await fetchPurchaseVouchersBySupplier(supplierId);
      const pvData = Array.isArray(response)
        ? response
        : response?.results || response?.data || [];

      const filteredPurchaseVouchers = pvData.map((pv) => ({
        id: pv.purchase_voucher_no,
        voucher_no: pv.purchase_number || pv.voucher_number,
        total_amount: parseFloat(pv.total_amount) || 0,
        remaining_amount:
          parseFloat(pv.balance_amount) || parseFloat(pv.total_amount) || 0,
        paid_amount: "",
        type: "purchase",
      }));

      setPurchaseVouchers(filteredPurchaseVouchers);
      setSelectedVouchers(filteredPurchaseVouchers);
      toast.success(
        `Found ${filteredPurchaseVouchers.length} purchase voucher(s)`
      );
    } catch (error) {
      toast.error("Failed to fetch purchase vouchers");
    }
  };

  const fetchJournalVouchersBySupplierAPI = async (supplierId) => {
    try {
      const response = await fetchJournalVouchersBySupplier(supplierId);
      const jvData = Array.isArray(response)
        ? response
        : response?.results || response?.data || [];

      const filteredJournalVouchers = jvData.map((jv) => ({
        id: jv.gen_voucher_no,
        voucher_no: jv.gen_number || jv.voucher_number,
        bill_no: jv.bill_no,
        total_amount:
          parseFloat(jv.grandtotal) ||
          parseFloat(jv.sub_vouchers?.[0]?.amount) ||
          parseFloat(jv.total_amount) ||
          0,
        remaining_amount: parseFloat(jv.balance_amount) || 0,
        paid_amount: "",
        type: "journal",
      }));

      setJournalVouchers(filteredJournalVouchers);
      setSelectedVouchers(filteredJournalVouchers);

      if (filteredJournalVouchers.length === 0) {
        toast.info("No journal vouchers found for this supplier");
      } else {
        toast.success(
          `Found ${filteredJournalVouchers.length} journal voucher(s)`
        );
      }
    } catch (error) {
      toast.error("Failed to fetch journal vouchers");
    }
  };

  const fetchJournalVouchersByImprestAPI = async (imprestId) => {
    try {
      const response = await fetchJournalVouchersByImprest(imprestId);
      const jvData = Array.isArray(response)
        ? response
        : response?.results || response?.data || [];

      const filteredJournalVouchers = jvData.map((jv) => ({
        id: jv.gen_voucher_no,
        voucher_no: jv.gen_number || jv.voucher_number,
        total_amount:
          parseFloat(jv.grandtotal) ||
          parseFloat(jv.sub_vouchers?.[0]?.amount) ||
          parseFloat(jv.total_amount) ||
          0,
        remaining_amount: parseFloat(jv.balance_amount) || 0,
        paid_amount: "",
        type: "journal",
      }));

      setJournalVouchers(filteredJournalVouchers);
      setSelectedVouchers(filteredJournalVouchers);
      toast.success(
        `Found ${filteredJournalVouchers.length} journal voucher(s)`
      );
    } catch (error) {
      toast.error("Failed to fetch journal vouchers");
    }
  };

  const addExpenseRow = () => {
    if (expenseRows.length >= 5) {
      toast.warning("Maximum 5 expense rows allowed");
      return;
    }
    setExpenseRows([...expenseRows, { expense: "", amount: "" }]);
  };

  const removeExpenseRow = (index) => {
    if (expenseRows.length > 1) {
      setExpenseRows(expenseRows.filter((_, i) => i !== index));
    }
  };

  const handleExpenseRowChange = (index, field, value) => {
    setExpenseRows((prev) => {
      const updated = [...prev];
      updated[index][field] = value;
      return updated;
    });
  };

  const calculateTotalAmount = () => {
    return expenseRows
      .reduce((total, row) => {
        return total + (parseFloat(row.amount) || 0);
      }, 0)
      .toFixed(2);
  };

  const handleAdjustAmountChange = (voucherIndex, adjustAmount) => {
    setSelectedVouchers((prev) => {
      const updated = [...prev];
      const voucher = updated[voucherIndex];
      const remainingAmount = parseFloat(voucher.remaining_amount) || 0;
      const adjust = parseFloat(adjustAmount) || 0;
      if (adjust > remainingAmount) {
        toast.warning(
          `Adjust amount cannot exceed remaining amount (₹${remainingAmount.toFixed(
            2
          )})`
        );
        updated[voucherIndex] = {
          ...voucher,
          paid_amount: remainingAmount.toFixed(2),
        };
      } else {
        updated[voucherIndex] = {
          ...voucher,
          paid_amount: adjustAmount,
        };
      }
      return updated;
    });
  };

  const formatDisplayDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}/${month}/${year}`;
  };

  const calculateTotalAdjustAmount = () => {
    return selectedVouchers
      .reduce((total, voucher) => {
        return total + (parseFloat(voucher.paid_amount) || 0);
      }, 0)
      .toFixed(2);
  };

  useEffect(() => {
    fetchAllData();
    if (!isEditMode) {
      generateVoucherNumber();
      // ✅ Set current date automatically
      setPaymentDate(getCurrentDateForState());
    }
    fetchLedgersWithSearch("");
  }, []);

  useEffect(() => {
    return () => {
      ledgerCache.current.clear();
    };
  }, []);

  const fetchAllData = async () => {
    try {
      const [
        bank,
        divisions,
        expenseData,
        purchaseVoucher,
        journalVoucher,
        projects,
      ] = await Promise.all([
        BankDetailList(),
        DivisionList(),
        ApproveExpenseList(),
        GetApprovedPVs(),
        GetApproveGVs(),
        ApproveSolistapi(),
      ]);

      const projectsData = Array.isArray(projects)
        ? projects
        : projects?.results || projects?.data || [];
      setProjectLists(
        projectsData.map((proj) => ({
          id: proj.id,
          name: proj.project_name || proj.name || `Project ${proj.id}`,
        }))
      );
      setBankDetails(Array.isArray(bank) ? bank : bank?.results || []);
      setExpenses(
        Array.isArray(expenseData) ? expenseData : expenseData?.results || []
      );

      const pvData = Array.isArray(purchaseVoucher)
        ? purchaseVoucher
        : purchaseVoucher?.results || [];
      const allPVData = pvData.map((pv) => ({
        id: pv.id || pv.purchase_id || pv.purchase_voucher_no,
        voucher_no: pv.purchase_number,
        total_amount: parseFloat(pv.total_amount) || 0,
        remaining_amount:
          parseFloat(pv.balance_amount) || parseFloat(pv.total_amount) || 0,
        paid_amount: "",
        type: "purchase",
      }));
      setAllPurchaseVouchers(allPVData);
      setPurchaseVouchers(allPVData);

      const jvData = Array.isArray(journalVoucher)
        ? journalVoucher
        : journalVoucher?.results || [];
      const allJVData = jvData.map((jv) => ({
        id: jv.id || jv.journal_id || jv.gen_voucher_no,
        voucher_no: jv.gen_number,
        total_amount:
          parseFloat(jv.grandtotal) ||
          parseFloat(jv.sub_vouchers?.[0]?.amount) ||
          0,
        remaining_amount: parseFloat(jv.balance_amount) || 0,
        paid_amount: "",
        type: "journal",
      }));
      setAllJournalVouchers(allJVData);
      setJournalVouchers(allJVData);

      const divisionsArray = Array.isArray(divisions)
        ? divisions
        : divisions?.results || [];
      setDivisionLists(
        divisionsArray.map((div) => ({
          id: div.division_id,
          name: div.division,
        }))
      );
    } catch (error) {
      toast.error("Error fetching initial data");
      setBankDetails([]);
      setDivisionLists([]);
      setExpenses([]);
      setPurchaseVouchers([]);
      setJournalVouchers([]);
      setAllJournalVouchers([]);
      setAllPurchaseVouchers([]);
      setProjectLists([]);
    }
  };

  const generateVoucherNumber = async () => {
    try {
      const data = await GeneratePaymentVoucherNo();
      if (data && data.payment_voucher_no) {
        setPaymentNumber(data.payment_voucher_no);
      }
    } catch (error) {
      toast.error("Failed to generate voucher number");
    }
  };

  useEffect(() => {
    if (isEditMode && editData) {
      setEditMode(true);
      setCurrentEditId(editData.payment_voucher_no);

      if (editData.attachment) {
        setAttachment(editData.attachment); // ✅ Set attachment URL

        const fullPath = editData.attachment.split("/").pop();
        const fileName = fullPath.split("?")[0];

        if (fileName.length > 20) {
          const ext = fileName.split(".").pop();
          const name = fileName.substring(0, 15);
          setExistingFileName(`${name}...${ext}`);
        } else {
          setExistingFileName(fileName);
        }
      }

      let ledgerTypeValue = "";
      if (editData.party) ledgerTypeValue = "Party";
      else if (editData.supplier) ledgerTypeValue = "Supplier";
      else if (editData.imprest_account) ledgerTypeValue = "Imprest";
      else if (editData.advance_worker) ledgerTypeValue = "AdvanceWorker";
      else if (editData.expense) ledgerTypeValue = "Expense";
      else if (editData.transporter) ledgerTypeValue = "Transporter";

      setPaymentVoucherNo(editData.payment_voucher_no || "");
      setPaymentNumber(editData.payment_number || "");
      setParty(editData.party || null);
      setPartyName(editData.party_name || "");
      setSupplier(editData.supplier || null);
      setSupplierName(editData.supplier_name || "");
      setImprestAccount(editData.imprest_account || null);
      setImprestAccountName(editData.imprest_account_name || "");
      setAdvanceWorker(editData.advance_worker || null);
      setAdvanceWorkerName(editData.advance_worker_name || "");
      setExpense(editData.expense || null);
      setExpenseName(editData.expense_name || "");
      setProject(editData.project || "");
      setProjectName(editData.project_name || "");
      setLedgerType(ledgerTypeValue);
      setDivision(editData.division || "");
      setDivisionName(editData.division_name || "");
      setMethodOfPayment(editData.method_of_payment || "");
      setChequeDate(editData.cheque_date || "");
      setPaymentDate(editData.payment_date || "");
      setVoucherType(editData.voucher_type || "");
      setTransporter(editData.transporter || null);
      setTransporterName(editData.transporter_name || "");
      setTotalAmount(editData.total_amount || "");
      setPaymentMode(editData.payment_mode || "");
      setDescription(editData.description || "");
      setRecommendedBy(editData.recommended_by || "");
      setBank(editData.bank || "");
      setNarration(editData.narration || "");

      if (editData.is_neft_rtgs) {
        setIsNeftRtgs(true);
        setShowNeftRtgsDetails(true);
        setNeftRtgsAccountNumber(editData.account_number || "");
        setNeftRtgsIfscCode(editData.ifsc_code || "");
        setNeftRtgsBankName(editData.bank_name_fk || "");
        setNeftRtgsBranchName(editData.branch_name || "");
      } else {
        setIsNeftRtgs(true);
        setShowNeftRtgsDetails(true);
        setNeftRtgsAccountNumber("");
        setNeftRtgsIfscCode("");
        setNeftRtgsBankName("");
        setNeftRtgsBranchName("");
      }

      if (
        (editData.voucher_type === "purchase" ||
          editData.voucher_type === "journal") &&
        editData.payment_subvoucher &&
        editData.payment_subvoucher.length > 0
      ) {
        const voucherData = editData.payment_subvoucher.map((ref) => ({
          id: ref.purchase_voucher || ref.journal_voucher,
          voucher_no: ref.purchase_voucher_no || ref.journal_voucher_no || "",
          total_amount: ref.journal_voucher
            ? parseFloat(ref.journal_grandtotal) ||
            parseFloat(ref.journal_total_amount) ||
            0
            : parseFloat(ref.purchase_total_amount) || 0,
          bill_no: ref.journal_bill_no || "",
          remaining_amount: parseFloat(
            ref.purchase_rem_amount || ref.journal_rem_amount || 0
          ),
          paid_amount: parseFloat(ref.paid_amount || 0).toString(),
          type: ref.purchase_voucher ? "purchase" : "journal",
        }));

        setSelectedVouchers(voucherData);

        if (editData.voucher_type === "purchase") {
          setPurchaseVouchers(voucherData);
        } else if (editData.voucher_type === "journal") {
          setJournalVouchers(voucherData);
        }
      }

      // ✅ IMPROVED: Create manual ledger for ALL types if not found
      if (ledgerTypeValue && ledgers.length > 0) {
        const matchingLedger = ledgers.find((l) => {
          if (ledgerTypeValue === "Party" && editData.party)
            return l.id === editData.party && l.type === "Party";
          if (ledgerTypeValue === "Supplier" && editData.supplier)
            return l.id === editData.supplier && l.type === "Supplier";
          if (ledgerTypeValue === "Imprest" && editData.imprest_account)
            return l.id === editData.imprest_account && l.type === "Imprest";
          if (ledgerTypeValue === "AdvanceWorker" && editData.advance_worker)
            return (
              l.id === editData.advance_worker && l.type === "AdvanceWorker"
            );
          if (ledgerTypeValue === "Transporter" && editData.transporter)
            return l.id === editData.transporter && l.type === "Transporter";
          if (ledgerTypeValue === "Expense" && editData.expense)
            return l.id === editData.expense && l.type === "Expense";
          return false;
        });

        if (matchingLedger) {
          setSelectedLedger(matchingLedger);
          setLedgerInputValue(matchingLedger.name || "");
        } else {
          // ✅ Create manual ledger for ALL types
          let manualLedger = null;

          if (ledgerTypeValue === "Party" && editData.party) {
            manualLedger = {
              id: editData.party,
              name: editData.party_name,
              type: "Party",
            };
          } else if (ledgerTypeValue === "Supplier" && editData.supplier) {
            manualLedger = {
              id: editData.supplier,
              name: editData.supplier_name,
              type: "Supplier",
            };
          } else if (
            ledgerTypeValue === "Imprest" &&
            editData.imprest_account
          ) {
            manualLedger = {
              id: editData.imprest_account,
              name: editData.imprest_account_name,
              type: "Imprest",
            };
          } else if (
            ledgerTypeValue === "AdvanceWorker" &&
            editData.advance_worker
          ) {
            manualLedger = {
              id: editData.advance_worker,
              name: editData.advance_worker_name,
              type: "AdvanceWorker",
            };
          } else if (
            ledgerTypeValue === "Transporter" &&
            editData.transporter
          ) {
            manualLedger = {
              id: editData.transporter,
              name: editData.transporter_name,
              type: "Transporter",
            };
          } else if (ledgerTypeValue === "Expense" && editData.expense) {
            manualLedger = {
              id: editData.expense,
              name: editData.expense_name,
              type: "Expense",
            };
          }

          if (manualLedger) {
            setSelectedLedger(manualLedger);
            setLedgerInputValue(manualLedger.name || "");
          }
        }
      }
    } else {
      setEditMode(false);
      setCurrentEditId(null);
    }
  }, [isEditMode, editData, ledgers]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitLoading(true);
    const userId = Number(localStorage.getItem("user_id"));

    try {
      // ✅ VALIDATION - expense को include करें
      const errors = {};

      if (
        !ledgerType ||
        (!party &&
          !supplier &&
          !imprestAccount &&
          !transporter &&
          !advanceWorker &&
          !expense)
      ) {
        errors.ledger = "Ledger name is required";
        toast.error("Please select a ledger name");
      }

      if (!methodOfPayment) {
        errors.method_of_payment = "Method of payment is required";
        toast.error("Please select a method of payment");
      }

      if (Object.keys(errors).length > 0) {
        setFormErrors(errors);
        setSubmitLoading(false);
        return;
      }

      const formData = new FormData();

      // ✅ Add all fields to formData
      const formFields = {
        payment_voucher_no: paymentVoucherNo,
        payment_number: paymentNumber,
        party,
        party_name: partyName,
        project,
        project_name: projectName,
        supplier,
        supplier_name: supplierName,
        imprest_account: imprestAccount,
        imprest_account_name: imprestAccountName,
        advance_worker: advanceWorker,
        advance_worker_name: advanceWorkerName,
        expense: expense, // ✅ EXPENSE FIELD ADD
        ledger_type: ledgerType,
        division,
        division_name: divisionName,
        cheque_date: chequeDate,
        payment_date: paymentDate,
        method_of_payment: methodOfPayment,
        voucher_type: voucherType,
        transporter,
        transporter_name: transporterName,
        total_amount: totalAmount,
        payment_mode: paymentMode,
        description,
        recommended_by,
        bank,
        narration,
        is_neft_rtgs: "true",
        payment_mode: "Cheque",
      };

      Object.keys(formFields).forEach((key) => {
        if (formFields[key] !== null && formFields[key] !== "") {
          formData.append(key, formFields[key]);
        }
      });

      // ✅ Add NEFT/RTGS details only if checkbox is checked
      if (isNeftRtgs && showNeftRtgsDetails) {
        if (neftRtgsAccountNumber)
          formData.append("account_no", neftRtgsAccountNumber);
        if (neftRtgsIfscCode) formData.append("ifsc_code", neftRtgsIfscCode);
        if (neftRtgsBankName) formData.append("bank_name", neftRtgsBankName);
        if (neftRtgsBranchName)
          formData.append("branch_name", neftRtgsBranchName);
      }

      if (attachment instanceof File) {
        formData.append("attachment", attachment);
      }

      // ✅ For PURCHASE/JOURNAL type
      if (voucherType === "purchase" || voucherType === "journal") {
        const vouchersWithAdjust = selectedVouchers.filter(
          (v) => parseFloat(v.paid_amount) > 0
        );

        if (vouchersWithAdjust.length === 0) {
          toast.error(
            "Please select at least one voucher and enter paid amount"
          );
          setSubmitLoading(false);
          return;
        }

        const references = vouchersWithAdjust.map((v) => ({
          purchase_voucher: v.type === "purchase" ? v.id : null,
          journal_voucher: v.type === "journal" ? v.id : null,
          paid_amount: parseFloat(v.paid_amount),
        }));

        formData.append("references", JSON.stringify(references));
        formData.append("total_amount", calculateTotalAdjustAmount());
      }

      if (editMode) {
        formData.append("updated_by", userId);
        await PaymentVoucherUpdate(currentEditId, formData);
        toast.success("Payment voucher updated successfully!");
      } else {
        formData.append("created_by", userId);
        await PaymentVoucherCreate(formData);
        toast.success("Payment voucher created successfully!");
      }

      // ✅ Reset form
      setExpenseRows([{ expense: "", amount: "" }]);
      setSelectedVouchers([]);
      setShowNeftRtgsDetails(false);
      setNeftRtgsAccountNumber("");
      setNeftRtgsIfscCode("");
      setNeftRtgsBankName("");
      setNeftRtgsBranchName("");
      if (!editMode) {
        generateVoucherNumber();
      }
      navigate("/dashboard/payment-rtgs");
      setFormErrors({});
    } catch (error) {
      if (error.response?.data) {
        const errorData = error.response.data;
        if (errorData.payment_number) {
          toast.error("Payment number already exists!");
        } else if (typeof errorData === "object") {
          const firstError = Object.values(errorData)[0];
          toast.error(Array.isArray(firstError) ? firstError[0] : firstError);
        } else {
          toast.error("Operation failed");
        }
      } else {
        toast.error("Operation failed");
      }
    } finally {
      setSubmitLoading(false);
    }
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />

      <Box sx={{ p: isMobile ? 1 : 3, maxWidth: 1400, mx: "auto" }}>
        <form onSubmit={handleSubmit}>
          <Card sx={{ mb: 3, backgroundColor: "#fff" }}>
            <CardContent>
              <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={12} md={3}>
                  <Autocomplete
                    options={ledgerOptions}
                    getOptionLabel={(option) => option?.name || ""}
                    loading={ledgerLoading}
                    value={
                      selectedLedger ||
                      ledgerOptions.find((l) => {
                        if (ledgerType === "Party" && party) {
                          return l.id === party && l.type === "Party";
                        }
                        if (ledgerType === "Supplier" && supplier) {
                          return l.id === supplier && l.type === "Supplier";
                        }
                        if (ledgerType === "Imprest" && imprestAccount) {
                          return (
                            l.id === imprestAccount && l.type === "Imprest"
                          );
                        }
                        if (ledgerType === "AdvanceWorker" && advanceWorker) {
                          return (
                            l.id === advanceWorker && l.type === "AdvanceWorker"
                          );
                        }
                        if (ledgerType === "Transporter" && transporter) {
                          return (
                            l.id === transporter && l.type === "Transporter"
                          );
                        }
                        if (ledgerType === "Expense" && expense) {
                          return l.id === expense && l.type === "Expense";
                        }
                        return false;
                      }) ||
                      null
                    }
                    onChange={(e, newValue) => handleLedgerChange(newValue)}
                    inputValue={ledgerInputValue}
                    onInputChange={(event, newInputValue, reason) => {
                      setLedgerInputValue(newInputValue);
                      if (reason === "input") {
                        debouncedLedgerSearch(newInputValue);
                      } else if (reason === "clear") {
                        debouncedLedgerSearch("");
                      }
                    }}
                    filterOptions={(x) => x}
                    isOptionEqualToValue={(option, value) =>
                      option?.id === value?.id && option?.type === value?.type
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Ledger Name *"
                        size="small"
                        error={!!formErrors.ledger}
                        helperText={formErrors.ledger}
                        sx={{ "& .MuiInputBase-root": { height: 42 } }}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {ledgerLoading ? (
                                <CircularProgress color="inherit" size={20} />
                              ) : null}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12} md={3}>
                  <Autocomplete
                    options={bankDetails}
                    getOptionLabel={(option) =>
                      `${option.bank_name || "Bank"} - ${option.account_number}`
                    }
                    value={
                      bankDetails.find((bankItem) => bankItem.id === bank) ||
                      null
                    }
                    onChange={(e, newValue) => {
                      setBank(newValue ? newValue.id : "");
                      setSelectedBank(newValue || null);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Bank Details *"
                        size="small"
                        sx={{ "& .MuiInputBase-root": { height: 42 } }}
                      />
                    )}
                    isOptionEqualToValue={(option, value) =>
                      option?.id === value?.id
                    }
                  />
                </Grid>

                <Grid item xs={12} sm={2.5}>
                  <TextField
                    fullWidth
                    label="Check No."
                    name="cheque_no"
                    value={chequeNo}                           // ✅ State se value
                    onChange={(e) => setChequeNo(e.target.value)}  // ✅ State update
                    size="small"
                    sx={{ "& .MuiInputBase-root": { height: 42 } }}
                  />
                </Grid>

                <Grid item xs={12} md={2.5}>
                  <TextField
                    fullWidth
                    label="Amount *"
                    type="number"
                    value={totalAmount || ""}
                    onChange={(e) => setTotalAmount(e.target.value)}
                    size="small"
                    inputProps={{ min: 0, step: 0.01 }}
                    sx={{ "& .MuiInputBase-root": { height: 42 } }}
                  />
                </Grid>

                <Grid item xs={12} sm={0.5}>
                  <Tooltip title="Print Challan" arrow>
                    <span>
                      <IconButton
                        color="primary"
                        size="small"
                        onClick={handlePrint}
                      >
                        <PrintIcon fontSize="small" />
                      </IconButton>
                    </span>
                  </Tooltip>
                </Grid>

                {/* ✅ NEW: Download Icon */}
                <Grid item xs={12} sm={0.5}>
                  <Tooltip title="Download Challan" arrow>
                    <span>
                      <IconButton
                        color="primary"
                        size="small"
                        onClick={handlePdfDownload} // Same function use kar sakte ho
                      >
                        <DownloadIcon fontSize="small" />
                      </IconButton>
                    </span>
                  </Tooltip>
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          {/* </Card> */}

          {/* -------- FULL NEFT / RTGS CHALLAN PREVIEW (IMAGE जैसा) -------- */}
          <Box
            sx={{
              display: "flex",
              // flexDirection: "row",
              flexDirection: isMobile ? "column" : "row", // ✅ Mobile me column
              gap: 2, // dono boxes ke beech spacing
              justifyContent: "center", // center align
              alignItems: "flex-start", // top se start
              flexWrap: "nowrap", // "wrap" hatao, "nowrap" rakho
            }}
          >
            <Box
              sx={{
           
                mt: 3,
                p: 2,
                border: "2px solid #000",
                backgroundColor: "#fff",
                fontSize: "12px",
                flex: isMobile ? "1 1 100%" : "1 1 50%", // ✅ Mobile me 100%
                maxWidth: isMobile ? "100%" : "50%",     // ✅ Mobile me full width
                minWidth: isMobile ? "100%" : "400px",   // ✅ Mobile me responsive
              }}
            >
              {/* <Typography
                align="center"
                sx={{ fontWeight: "bold", fontSize: "18px" }}
              >
                इंडियन ओवरसीज बैंक, रायपुर
              </Typography> */}
              <Typography align="center" sx={{ fontWeight: "bold" }}>
                INDIAN OVERSEAS BANK , RAIPUR
              </Typography>
              <Typography align="center" sx={{ fontWeight: "bold", mb: 1 }}>
                NEFT REMITTANCE CHALLAN BRANCH COPY
              </Typography>

              {/* A) Particulars of Sender */}
              <Box sx={{ border: "1px solid #000" }}>
                <Box
                  sx={{
                    borderBottom: "1px solid #000",
                    p: 0.5,
                    fontWeight: "bold",
                  }}
                >
                  A) Particulars of Sender
                </Box>

                <Grid container sx={{ borderBottom: "1px solid #000" }}>
                  <Grid
                    item
                    xs={4}
                    sx={{ borderRight: "1px solid #000", p: 0.5 }}
                  >
                    1 Name:-
                  </Grid>
                  <Grid item xs={8} sx={{ p: 0.5, fontWeight: "bold" }}>
                    {senderName}
                  </Grid>
                </Grid>

                <Grid container sx={{ borderBottom: "1px solid #000" }}>
                  <Grid
                    item
                    xs={4}
                    sx={{ borderRight: "1px solid #000", p: 0.5 }}
                  >
                    2 Address:-
                  </Grid>
                  <Grid item xs={8} sx={{ p: 0.5 }}>
                    {senderAddress || "\u00A0"}
                  </Grid>
                </Grid>

                <Grid container>
                  <Grid
                    item
                    xs={4}
                    sx={{
                      borderRight: "1px solid #000",
                      borderTop: "1px solid #000",
                      p: 0.5,
                    }}
                  >
                    3 Contact No. Phone
                  </Grid>
                  <Grid
                    item
                    xs={8}
                    sx={{ borderTop: "1px solid #000", p: 0.5 }}
                  >
                    {senderContactNo || "\u00A0"}
                  </Grid>

                  <Grid
                    item
                    xs={4}
                    sx={{
                      borderRight: "1px solid #000",
                      borderTop: "1px solid #000",
                      p: 0.5,
                    }}
                  >
                    mobile :-
                  </Grid>
                  <Grid
                    item
                    xs={8}
                    sx={{ borderTop: "1px solid #000", p: 0.5 }}
                  >
                    {senderMobile || "\u00A0"}
                  </Grid>

                  <Grid
                    item
                    xs={4}
                    sx={{
                      borderRight: "1px solid #000",
                      borderTop: "1px solid #000",
                      p: 0.5,
                    }}
                  >
                    email :-
                  </Grid>
                  <Grid
                    item
                    xs={8}
                    sx={{ borderTop: "1px solid #000", p: 0.5 }}
                  >
                    {senderEmail || "\u00A0"}
                  </Grid>
                </Grid>

                <Grid
                  container
                  sx={{
                    borderTop: "1px solid #000",
                    borderBottom: "1px solid #000",
                  }}
                >
                  <Grid
                    item
                    xs={4}
                    sx={{ borderRight: "1px solid #000", p: 0.5 }}
                  >
                    4 type of account :- {senderAccountType || "\u00A0"}
                  </Grid>
                  <Grid item xs={8} sx={{ p: 0.5 }}>
                    A/c. NO. :- {senderAccountNo || "\u00A0"}
                  </Grid>
                </Grid>

                <Grid container sx={{ borderBottom: "1px solid #000" }}>
                  <Grid
                    item
                    xs={4}
                    sx={{ borderRight: "1px solid #000", p: 0.5 }}
                  >
                    5 Amount to be remitted :
                  </Grid>
                  <Grid item xs={8} sx={{ p: 0.5 }}>
                    Rs. {amountNumber.toFixed(2)}
                  </Grid>
                </Grid>

                <Box sx={{ borderTop: "1px solid #000", p: 0.5 }}>
                  (Rs. {amountInWords || "\u00A0"})
                </Box>
              </Box>

              {/* 6 Amount of Remittance / Charges / Total */}
              <Box sx={{ border: "1px solid #000", borderTop: "none" }}>
                <Grid container sx={{ borderBottom: "1px solid #000" }}>
                  <Grid
                    item
                    xs={4}
                    sx={{ borderRight: "1px solid #000", p: 0.5 }}
                  >
                    6 Amount of Remittance
                  </Grid>
                  <Grid
                    item
                    xs={2}
                    sx={{ borderRight: "1px solid #000", p: 0.5 }}
                  >
                    Rs. {amountNumber.toFixed(2)}
                  </Grid>
                  <Grid
                    item
                    xs={3}
                    sx={{ borderRight: "1px solid #000", p: 0.5 }}
                  >
                    charges
                  </Grid>
                  <Grid item xs={3} sx={{ p: 0.5 }}>
                    Rs. {neftCharges || "\u00A0"}
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid
                    item
                    xs={7}
                    sx={{
                      borderRight: "1px solid #000",
                      p: 0.5,
                      textAlign: "right",
                      fontWeight: "bold",
                    }}
                  >
                    Total
                  </Grid>
                  <Grid item xs={5} sx={{ p: 0.5 }}>
                    Rs. {amountNumber.toFixed(2)}
                  </Grid>
                </Grid>
              </Box>

              {/* 7 Cheque & debit account */}
              <Box sx={{ border: "1px solid #000", borderTop: "none" }}>
                <Grid container sx={{ borderBottom: "1px solid #000" }}>
                  <Grid
                    item
                    xs={6}
                    sx={{ borderRight: "1px solid #000", p: 0.5 }}
                  >
                    7 Please find enclosed Cheque no.
                  </Grid>
                  <Grid item xs={6} sx={{ p: 0.5 }}>
                    <TextField
                      variant="standard"
                      fullWidth
                      value={chequeNo}
                      onChange={(e) => setChequeNo(e.target.value)}
                      InputProps={{
                        disableUnderline: true,
                        sx: {
                          fontSize: "12px",
                          padding: "2px 4px",
                          border: "1px solid #094274ff",
                          borderRadius: "3px",
                          cursor: "text",
                        },
                      }}
                    />
                  </Grid>
                </Grid>
                <Box sx={{ borderBottom: "1px solid #000", p: 0.5 }}>
                  Debit my account-
                </Box>
                <Box sx={{ p: 0.5 }}>(Rs. {amountInWords || "\u00A0"})</Box>
              </Box>

              {/* 8 Particulars of Beneficiary */}
              <Box sx={{ border: "1px solid #000", borderTop: "none" }}>
                <Box
                  sx={{
                    borderBottom: "1px solid #000",
                    p: 0.5,
                    fontWeight: "bold",
                  }}
                >
                  8 Particulars of Beneficiary
                </Box>

                {/* 1 IFSC Code */}
                <Grid container sx={{ borderBottom: "1px solid #000" }}>
                  <Grid
                    item
                    xs={4}
                    sx={{ borderRight: "1px solid #000", p: 0.5 }}
                  >
                    1 IFSC Code:
                  </Grid>
                  <Grid item xs={8} sx={{ p: 0.5 }}>
                    <TextField
                      variant="standard"
                      fullWidth
                      value={neftRtgsIfscCode}
                      onChange={(e) => setNeftRtgsIfscCode(e.target.value)}
                      InputProps={{
                        disableUnderline: true,
                        sx: {
                          fontSize: "12px",
                          padding: "2px 4px",
                          border: "1px solid #094274ff",
                          borderRadius: "3px",
                          cursor: "text",
                        },
                      }}
                    />
                  </Grid>
                </Grid>

                {/* 2 Account with Bank */}
                <Grid container sx={{ borderBottom: "1px solid #000" }}>
                  <Grid
                    item
                    xs={4}
                    sx={{ borderRight: "1px solid #000", p: 0.5 }}
                  >
                    2. Account with Bank
                  </Grid>
                  <Grid item xs={8} sx={{ p: 0.5 }}>
                    <TextField
                      variant="standard"
                      fullWidth
                      value={neftRtgsBankName}
                      onChange={(e) => setNeftRtgsBankName(e.target.value)}
                      InputProps={{
                        disableUnderline: true,
                        sx: {
                          fontSize: "12px",
                          padding: "2px 4px",
                          border: "1px solid #094274ff",
                          borderRadius: "3px",
                          cursor: "text",
                        },
                      }}
                    />
                  </Grid>
                </Grid>

                {/* Name of Bank */}
                <Grid container sx={{ borderBottom: "1px solid #000" }}>
                  <Grid
                    item
                    xs={4}
                    sx={{ borderRight: "1px solid #000", p: 0.5 }}
                  >
                    Name of Bank
                  </Grid>
                  <Grid item xs={8} sx={{ p: 0.5 }}>
                    <TextField
                      variant="standard"
                      fullWidth
                      value={bankNameOf} // ✅ Changed
                      onChange={(e) => setBankNameOf(e.target.value)} // ✅ Changed
                      InputProps={{
                        disableUnderline: true,
                        sx: {
                          fontSize: "12px",
                          padding: "2px 4px",
                          border: "1px solid #094274ff",
                          borderRadius: "3px",
                          cursor: "text",
                        },
                      }}
                    />
                  </Grid>
                </Grid>

                {/* Branch */}
                <Grid container sx={{ borderBottom: "1px solid #000" }}>
                  <Grid
                    item
                    xs={4}
                    sx={{ borderRight: "1px solid #000", p: 0.5 }}
                  >
                    Branch
                  </Grid>
                  <Grid item xs={8} sx={{ p: 0.5 }}>
                    <TextField
                      variant="standard"
                      fullWidth
                      value={neftRtgsBranchName}
                      onChange={(e) => setNeftRtgsBranchName(e.target.value)}
                      InputProps={{
                        disableUnderline: true,
                        sx: {
                          fontSize: "12px",
                          padding: "2px 4px",
                          border: "1px solid #094274ff",
                          borderRadius: "3px",
                          cursor: "text",
                        },
                      }}
                    />
                  </Grid>
                </Grid>

                {/* Branch Address */}
                <Grid container sx={{ borderBottom: "1px solid #000" }}>
                  <Grid
                    item
                    xs={4}
                    sx={{ borderRight: "1px solid #000", p: 0.5 }}
                  >
                    3. Branch Address :-
                  </Grid>
                  <Grid item xs={8} sx={{ p: 0.5 }}>
                    <TextField
                      variant="standard"
                      fullWidth
                      multiline
                      value={branchAddress} // ✅ Changed
                      onChange={(e) => setBranchAddress(e.target.value)} // ✅ Changed
                      InputProps={{
                        disableUnderline: true,
                        sx: {
                          fontSize: "12px",
                          padding: "2px 4px",
                          border: "1px solid #094274ff",
                          borderRadius: "3px",
                          cursor: "text",
                        },
                      }}
                    />
                  </Grid>
                </Grid>

                {/* Type of Account */}
                <Grid container sx={{ borderBottom: "1px solid #000" }}>
                  <Grid
                    item
                    xs={4}
                    sx={{ borderRight: "1px solid #000", p: 0.5 }}
                  >
                    4 Type of Account
                  </Grid>
                  <Grid item xs={8} sx={{ p: 0.5 }}>
                    <TextField
                      variant="standard"
                      fullWidth
                      value={NeftRtgsAccountType}  // ✅ State variable
                      onChange={(e) => setNeftRtgsAccountType(e.target.value)}
                      InputProps={{
                        disableUnderline: true,
                        sx: {
                          fontSize: "12px",
                          padding: "2px 4px",
                          border: "1px solid #094274ff",
                          borderRadius: "3px",
                          cursor: "text",
                        },
                      }}
                    />
                  </Grid>
                </Grid>

                {/* Account No */}
                <Grid container sx={{ borderBottom: "1px solid #000" }}>
                  <Grid
                    item
                    xs={4}
                    sx={{ borderRight: "1px solid #000", p: 0.5 }}
                  >
                    5 Account No.
                  </Grid>
                  <Grid item xs={8} sx={{ p: 0.5 }}>
                    <TextField
                      variant="standard"
                      fullWidth
                      value={neftRtgsAccountNumber}
                      onChange={(e) => setNeftRtgsAccountNumber(e.target.value)}
                      InputProps={{
                        disableUnderline: true,
                        sx: {
                          fontSize: "12px",
                          padding: "2px 4px",
                          border: "1px solid #094274ff",
                          borderRadius: "3px",
                          cursor: "text",
                        },
                      }}
                    />
                  </Grid>
                </Grid>

                {/* Beneficiary Name */}
                <Grid container sx={{ borderBottom: "1px solid #000" }}>
                  <Grid
                    item
                    xs={4}
                    sx={{ borderRight: "1px solid #000", p: 0.5 }}
                  >
                    6. Beneficiary's Name
                  </Grid>
                  <Grid item xs={8} sx={{ p: 0.5 }}>
                    <TextField
                      variant="standard"
                      fullWidth
                      value={NeftRtgsName}
                      onChange={(e) => setNeftRtgsName(e.target.value)}
                      InputProps={{
                        disableUnderline: true,
                        sx: {
                          fontSize: "12px",
                          padding: "2px 4px",
                          border: "1px solid #094274ff",
                          borderRadius: "3px",
                          cursor: "text",
                        },
                      }}
                    />
                  </Grid>
                </Grid>

                {/* Beneficiary Address */}
                <Grid container sx={{ borderBottom: "1px solid #000" }}>
                  <Grid
                    item
                    xs={4}
                    sx={{ borderRight: "1px solid #000", p: 0.5 }}
                  >
                    7 Beneficiary's Address
                  </Grid>
                  <Grid item xs={8} sx={{ p: 0.5 }}>
                    <TextField
                      variant="standard"
                      fullWidth
                      multiline
                      value={NeftRtgsaddress}
                      onChange={(e) => setNeftRtgsaddress(e.target.value)}
                      InputProps={{
                        disableUnderline: true,
                        sx: {
                          fontSize: "12px",
                          padding: "2px 4px",
                          border: "1px solid #094274ff",
                          borderRadius: "3px",
                          cursor: "text",
                        },
                      }}
                    />
                  </Grid>
                </Grid>

                {/* Beneficiary Contact */}
                <Grid container sx={{ borderBottom: "1px solid #000" }}>
                  <Grid
                    item
                    xs={4}
                    sx={{ borderRight: "1px solid #000", p: 0.5 }}
                  >
                    8 Beneficiary's Contact No.
                  </Grid>
                  <Grid item xs={8} sx={{ p: 0.5 }}>
                    <TextField
                      variant="standard"
                      fullWidth
                      value={NeftRtgscontact}
                      onChange={(e) => setNeftRtgscontact(e.target.value)}
                      InputProps={{
                        disableUnderline: true,
                        sx: {
                          fontSize: "12px",
                          padding: "2px 4px",
                          border: "1px solid #094274ff",
                          borderRadius: "3px",
                          cursor: "text",
                        },
                      }}
                    />
                  </Grid>
                </Grid>

                {/* Date */}
                <Grid container>
                  <Grid
                    item
                    xs={4}
                    sx={{ borderRight: "1px solid #000", p: 0.5 }}
                  >
                    date:
                  </Grid>
                  <Grid item xs={8} sx={{ p: 0.5 }}>
                    {formatDisplayDate(paymentDate) || "\u00A0"}
                  </Grid>
                </Grid>
              </Box>

              {/* Signatures / NEFT UTR / Footer */}
              <Box sx={{ border: "1px solid #000", borderTop: "none" }}>
                <Grid container>
                  <Grid
                    item
                    xs={4}
                    sx={{
                      borderRight: "1px solid #000",
                      p: 0.5,
                      minHeight: 60,
                    }}
                  >
                    Applicant's Signatures
                  </Grid>
                  <Grid
                    item
                    xs={4}
                    sx={{
                      borderRight: "1px solid #000",
                      p: 0.5,
                      minHeight: 60,
                    }}
                  >
                    Branch Seal
                  </Grid>
                  <Grid item xs={4} sx={{ p: 0.5, minHeight: 60 }}>
                    Authorised Signatory
                  </Grid>
                </Grid>
              </Box>

              <Box sx={{ border: "1px solid #000", borderTop: "none" }}>
                <Grid container sx={{ borderBottom: "1px solid #000" }}>
                  <Grid
                    item
                    xs={4}
                    sx={{ borderRight: "1px solid #000", p: 0.5 }}
                  >
                    NEFT UTR NO.
                  </Grid>
                  <Grid item xs={8} sx={{ p: 0.5 }}>
                    {"\u00A0"}
                  </Grid>
                </Grid>
                <Grid container sx={{ borderBottom: "1px solid #000" }}>
                  <Grid
                    item
                    xs={4}
                    sx={{ borderRight: "1px solid #000", p: 0.5 }}
                  >
                    Received for remittance through NEFT
                  </Grid>
                  <Grid item xs={8} sx={{ p: 0.5 }}>
                    {"\u00A0"}
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid
                    item
                    xs={4}
                    sx={{ borderRight: "1px solid #000", p: 0.5 }}
                  >
                    Date
                  </Grid>
                  <Grid item xs={8} sx={{ p: 0.5 }}>
                    {"\u00A0"}
                  </Grid>
                </Grid>
              </Box>

              <Box sx={{ border: "1px solid #000", borderTop: "none", p: 0.5 }}>
                ** The Remittance Facility to a Bank otherr then Nepal SBI Bank
                Ltd., will be operational after RBI's notification
              </Box>
            </Box>
            <Box
              sx={{
                mt: 3,
                p: 2,
                border: "2px solid #000",
                backgroundColor: "#fff",
                fontSize: "12px",
                flex: "1 1 50%", // ADD THIS - equal width
                maxWidth: "50%", // ADD THIS
                minWidth: "400px", // ADD THIS
              }}
            >
              {/* <Typography
                align="center"
                sx={{ fontWeight: "bold", fontSize: "18px" }}
              >
                इंडियन ओवरसीज बैंक, रायपुर
              </Typography> */}
              <Typography align="center" sx={{ fontWeight: "bold" }}>
                INDIAN OVERSEAS BANK , RAIPUR
              </Typography>
              <Typography align="center" sx={{ fontWeight: "bold", mb: 1 }}>
                NEFT REMITTANCE CHALLAN BRANCH COPY
              </Typography>

              {/* A) Particulars of Sender */}
              <Box sx={{ border: "1px solid #000" }}>
                <Box
                  sx={{
                    borderBottom: "1px solid #000",
                    p: 0.5,
                    fontWeight: "bold",
                  }}
                >
                  A) Particulars of Sender
                </Box>

                <Grid container sx={{ borderBottom: "1px solid #000" }}>
                  <Grid
                    item
                    xs={4}
                    sx={{ borderRight: "1px solid #000", p: 0.5 }}
                  >
                    1 Name:-
                  </Grid>
                  <Grid item xs={8} sx={{ p: 0.5, fontWeight: "bold" }}>
                    {senderName}
                  </Grid>
                </Grid>

                <Grid container sx={{ borderBottom: "1px solid #000" }}>
                  <Grid
                    item
                    xs={4}
                    sx={{ borderRight: "1px solid #000", p: 0.5 }}
                  >
                    2 Address:-
                  </Grid>
                  <Grid item xs={8} sx={{ p: 0.5 }}>
                    {senderAddress || "\u00A0"}
                  </Grid>
                </Grid>

                <Grid container>
                  <Grid
                    item
                    xs={4}
                    sx={{
                      borderRight: "1px solid #000",
                      borderTop: "1px solid #000",
                      p: 0.5,
                    }}
                  >
                    3 Contact No. Phone
                  </Grid>
                  <Grid
                    item
                    xs={8}
                    sx={{ borderTop: "1px solid #000", p: 0.5 }}
                  >
                    {senderContactNo || "\u00A0"}
                  </Grid>

                  <Grid
                    item
                    xs={4}
                    sx={{
                      borderRight: "1px solid #000",
                      borderTop: "1px solid #000",
                      p: 0.5,
                    }}
                  >
                    mobile :-
                  </Grid>
                  <Grid
                    item
                    xs={8}
                    sx={{ borderTop: "1px solid #000", p: 0.5 }}
                  >
                    {senderMobile || "\u00A0"}
                  </Grid>

                  <Grid
                    item
                    xs={4}
                    sx={{
                      borderRight: "1px solid #000",
                      borderTop: "1px solid #000",
                      p: 0.5,
                    }}
                  >
                    email :-
                  </Grid>
                  <Grid
                    item
                    xs={8}
                    sx={{ borderTop: "1px solid #000", p: 0.5 }}
                  >
                    {senderEmail || "\u00A0"}
                  </Grid>
                </Grid>

                <Grid
                  container
                  sx={{
                    borderTop: "1px solid #000",
                    borderBottom: "1px solid #000",
                  }}
                >
                  <Grid
                    item
                    xs={4}
                    sx={{ borderRight: "1px solid #000", p: 0.5 }}
                  >
                    4 type of account :- {senderAccountType || "\u00A0"}
                  </Grid>
                  <Grid item xs={8} sx={{ p: 0.5 }}>
                    A/c. NO. :- {senderAccountNo || "\u00A0"}
                  </Grid>
                </Grid>

                <Grid container sx={{ borderBottom: "1px solid #000" }}>
                  <Grid
                    item
                    xs={4}
                    sx={{ borderRight: "1px solid #000", p: 0.5 }}
                  >
                    5 Amount to be remitted :
                  </Grid>
                  <Grid item xs={8} sx={{ p: 0.5 }}>
                    Rs. {amountNumber.toFixed(2)}
                  </Grid>
                </Grid>

                <Box sx={{ borderTop: "1px solid #000", p: 0.5 }}>
                  (Rs. {amountInWords || "\u00A0"})
                </Box>
              </Box>

              {/* 6 Amount of Remittance / Charges / Total */}
              <Box sx={{ border: "1px solid #000", borderTop: "none" }}>
                <Grid container sx={{ borderBottom: "1px solid #000" }}>
                  <Grid
                    item
                    xs={4}
                    sx={{ borderRight: "1px solid #000", p: 0.5 }}
                  >
                    6 Amount of Remittance
                  </Grid>
                  <Grid
                    item
                    xs={2}
                    sx={{ borderRight: "1px solid #000", p: 0.5 }}
                  >
                    Rs. {amountNumber.toFixed(2)}
                  </Grid>
                  <Grid
                    item
                    xs={3}
                    sx={{ borderRight: "1px solid #000", p: 0.5 }}
                  >
                    charges
                  </Grid>
                  <Grid item xs={3} sx={{ p: 0.5 }}>
                    Rs. {neftCharges || "\u00A0"}
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid
                    item
                    xs={7}
                    sx={{
                      borderRight: "1px solid #000",
                      p: 0.5,
                      textAlign: "right",
                      fontWeight: "bold",
                    }}
                  >
                    Total
                  </Grid>
                  <Grid item xs={5} sx={{ p: 0.5 }}>
                    Rs. {amountNumber.toFixed(2)}
                  </Grid>
                </Grid>
              </Box>

              {/* 7 Cheque & debit account */}
              <Box sx={{ border: "1px solid #000", borderTop: "none" }}>
                <Grid container sx={{ borderBottom: "1px solid #000" }}>
                  <Grid
                    item
                    xs={6}
                    sx={{ borderRight: "1px solid #000", p: 0.5 }}
                  >
                    7 Please find enclosed Cheque no.
                  </Grid>
                  <Grid item xs={6} sx={{ p: 0.5 }}>
                    {chequeNo || "\u00A0"}
                  </Grid>
                </Grid>
                <Box sx={{ borderBottom: "1px solid #000", p: 0.5 }}>
                  Debit my account-
                </Box>
                <Box sx={{ p: 0.5 }}>(Rs. {amountInWords || "\u00A0"})</Box>
              </Box>

              {/* 8 Particulars of Beneficiary */}
              <Box sx={{ border: "1px solid #000", borderTop: "none" }}>
                <Box
                  sx={{
                    borderBottom: "1px solid #000",
                    p: 0.5,
                    fontWeight: "bold",
                  }}
                >
                  8 Particulars of Beneficiary
                </Box>

                {/* 1 IFSC Code */}
                <Grid container sx={{ borderBottom: "1px solid #000" }}>
                  <Grid
                    item
                    xs={4}
                    sx={{ borderRight: "1px solid #000", p: 0.5 }}
                  >
                    1 IFSC Code:
                  </Grid>
                  <Grid item xs={8} sx={{ p: 0.5 }}>
                    <TextField
                      variant="standard"
                      fullWidth
                      value={neftRtgsIfscCode}
                      onChange={(e) => setNeftRtgsIfscCode(e.target.value)}
                      InputProps={{
                        disableUnderline: true,
                        sx: {
                          fontSize: "12px",
                          padding: "2px 4px",
                          border: "1px solid #094274ff",
                          borderRadius: "3px",
                          cursor: "text",
                        },
                      }}
                    />
                  </Grid>
                </Grid>

                {/* 2 Account with Bank */}
                <Grid container sx={{ borderBottom: "1px solid #000" }}>
                  <Grid
                    item
                    xs={4}
                    sx={{ borderRight: "1px solid #000", p: 0.5 }}
                  >
                    2. Account with Bank
                  </Grid>
                  <Grid item xs={8} sx={{ p: 0.5 }}>
                    <TextField
                      variant="standard"
                      fullWidth
                      value={neftRtgsBankName}
                      onChange={(e) => setNeftRtgsBankName(e.target.value)}
                      InputProps={{
                        disableUnderline: true,
                        sx: {
                          fontSize: "12px",
                          padding: "2px 4px",
                          border: "1px solid #094274ff",
                          borderRadius: "3px",
                          cursor: "text",
                        },
                      }}
                    />
                  </Grid>
                </Grid>

                {/* Name of Bank */}
                <Grid container sx={{ borderBottom: "1px solid #000" }}>
                  <Grid
                    item
                    xs={4}
                    sx={{ borderRight: "1px solid #000", p: 0.5 }}
                  >
                    Name of Bank
                  </Grid>
                  <Grid item xs={8} sx={{ p: 0.5 }}>
                    <TextField
                      variant="standard"
                      fullWidth
                      value={bankNameOf} // ✅ Changed
                      onChange={(e) => setBankNameOf(e.target.value)} // ✅ Changed
                      InputProps={{
                        disableUnderline: true,
                        sx: {
                          fontSize: "12px",
                          padding: "2px 4px",
                          border: "1px solid #094274ff",
                          borderRadius: "3px",
                          cursor: "text",
                        },
                      }}
                    />
                  </Grid>
                </Grid>

                {/* Branch */}
                <Grid container sx={{ borderBottom: "1px solid #000" }}>
                  <Grid
                    item
                    xs={4}
                    sx={{ borderRight: "1px solid #000", p: 0.5 }}
                  >
                    Branch
                  </Grid>
                  <Grid item xs={8} sx={{ p: 0.5 }}>
                    <TextField
                      variant="standard"
                      fullWidth
                      value={neftRtgsBranchName}
                      onChange={(e) => setNeftRtgsBranchName(e.target.value)}
                      InputProps={{
                        disableUnderline: true,
                        sx: {
                          fontSize: "12px",
                          padding: "2px 4px",
                          border: "1px solid #094274ff",
                          borderRadius: "3px",
                          cursor: "text",
                        },
                      }}
                    />
                  </Grid>
                </Grid>

                {/* Branch Address */}
                <Grid container sx={{ borderBottom: "1px solid #000" }}>
                  <Grid
                    item
                    xs={4}
                    sx={{ borderRight: "1px solid #000", p: 0.5 }}
                  >
                    3. Branch Address :-
                  </Grid>
                  <Grid item xs={8} sx={{ p: 0.5 }}>
                    <TextField
                      variant="standard"
                      fullWidth
                      multiline
                      value={branchAddress} // ✅ Changed
                      onChange={(e) => setBranchAddress(e.target.value)} // ✅ Changed
                      InputProps={{
                        disableUnderline: true,
                        sx: {
                          fontSize: "12px",
                          padding: "2px 4px",
                          border: "1px solid #094274ff",
                          borderRadius: "3px",
                          cursor: "text",
                        },
                      }}
                    />
                  </Grid>
                </Grid>

                {/* Type of Account */}
                <Grid container sx={{ borderBottom: "1px solid #000" }}>
                  <Grid
                    item
                    xs={4}
                    sx={{ borderRight: "1px solid #000", p: 0.5 }}
                  >
                    4 Type of Account
                  </Grid>
                  <Grid item xs={8} sx={{ p: 0.5 }}>
                    <TextField
                      variant="standard"
                      fullWidth
                      value={NeftRtgsAccountType}  // ✅ State variable
                      onChange={(e) => setNeftRtgsAccountType(e.target.value)}
                      InputProps={{
                        disableUnderline: true,
                        sx: {
                          fontSize: "12px",
                          padding: "2px 4px",
                          border: "1px solid #094274ff",
                          borderRadius: "3px",
                          cursor: "text",
                        },
                      }}
                    />

                  </Grid>
                </Grid>

                {/* Account No */}
                <Grid container sx={{ borderBottom: "1px solid #000" }}>
                  <Grid
                    item
                    xs={4}
                    sx={{ borderRight: "1px solid #000", p: 0.5 }}
                  >
                    5 Account No.
                  </Grid>
                  <Grid item xs={8} sx={{ p: 0.5 }}>
                    <TextField
                      variant="standard"
                      fullWidth
                      value={neftRtgsAccountNumber}
                      onChange={(e) => setNeftRtgsAccountNumber(e.target.value)}
                      InputProps={{
                        disableUnderline: true,
                        sx: {
                          fontSize: "12px",
                          padding: "2px 4px",
                          border: "1px solid #094274ff",
                          borderRadius: "3px",
                          cursor: "text",
                        },
                      }}
                    />
                  </Grid>
                </Grid>

                {/* Beneficiary Name */}
                <Grid container sx={{ borderBottom: "1px solid #000" }}>
                  <Grid
                    item
                    xs={4}
                    sx={{ borderRight: "1px solid #000", p: 0.5 }}
                  >
                    6. Beneficiary's Name
                  </Grid>
                  <Grid item xs={8} sx={{ p: 0.5 }}>
                    <TextField
                      variant="standard"
                      fullWidth
                      value={NeftRtgsName}
                      onChange={(e) => setNeftRtgsName(e.target.value)}
                      InputProps={{
                        disableUnderline: true,
                        sx: {
                          fontSize: "12px",
                          padding: "2px 4px",
                          border: "1px solid #094274ff",
                          borderRadius: "3px",
                          cursor: "text",
                        },
                      }}
                    />
                  </Grid>
                </Grid>

                {/* Beneficiary Address */}
                <Grid container sx={{ borderBottom: "1px solid #000" }}>
                  <Grid
                    item
                    xs={4}
                    sx={{ borderRight: "1px solid #000", p: 0.5 }}
                  >
                    7 Beneficiary's Address
                  </Grid>
                  <Grid item xs={8} sx={{ p: 0.5 }}>
                    <TextField
                      variant="standard"
                      fullWidth
                      multiline
                      value={NeftRtgsaddress}
                      onChange={(e) => setNeftRtgsaddress(e.target.value)}
                      InputProps={{
                        disableUnderline: true,
                        sx: {
                          fontSize: "12px",
                          padding: "2px 4px",
                          border: "1px solid #094274ff",
                          borderRadius: "3px",
                          cursor: "text",
                        },
                      }}
                    />
                  </Grid>
                </Grid>

                {/* Beneficiary Contact */}
                <Grid container sx={{ borderBottom: "1px solid #000" }}>
                  <Grid
                    item
                    xs={4}
                    sx={{ borderRight: "1px solid #000", p: 0.5 }}
                  >
                    8 Beneficiary's Contact No.
                  </Grid>
                  <Grid item xs={8} sx={{ p: 0.5 }}>
                    <TextField
                      variant="standard"
                      fullWidth
                      value={NeftRtgscontact}
                      onChange={(e) => setNeftRtgscontact(e.target.value)}
                      InputProps={{
                        disableUnderline: true,
                        sx: {
                          fontSize: "12px",
                          padding: "2px 4px",
                          border: "1px solid #094274ff",
                          borderRadius: "3px",
                          cursor: "text",
                        },
                      }}
                    />
                  </Grid>
                </Grid>

                {/* Date */}

                {/* Date */}
                <Grid container>
                  <Grid
                    item
                    xs={4}
                    sx={{ borderRight: "1px solid #000", p: 0.5 }}
                  >
                    date:
                  </Grid>
                  <Grid item xs={8} sx={{ p: 0.5 }}>
                    {formatDisplayDate(paymentDate) || getCurrentDate()}
                  </Grid>
                </Grid>
              </Box>

              {/* Signatures / NEFT UTR / Footer */}
              <Box sx={{ border: "1px solid #000", borderTop: "none" }}>
                <Grid container>
                  <Grid
                    item
                    xs={4}
                    sx={{
                      borderRight: "1px solid #000",
                      p: 0.5,
                      minHeight: 60,
                    }}
                  >
                    Applicant's Signatures
                  </Grid>
                  <Grid
                    item
                    xs={4}
                    sx={{
                      borderRight: "1px solid #000",
                      p: 0.5,
                      minHeight: 60,
                    }}
                  >
                    Branch Seal
                  </Grid>
                  <Grid item xs={4} sx={{ p: 0.5, minHeight: 60 }}>
                    Authorised Signatory
                  </Grid>
                </Grid>
              </Box>

              <Box sx={{ border: "1px solid #000", borderTop: "none" }}>
                <Grid container sx={{ borderBottom: "1px solid #000" }}>
                  <Grid
                    item
                    xs={4}
                    sx={{ borderRight: "1px solid #000", p: 0.5 }}
                  >
                    NEFT UTR NO.
                  </Grid>
                  <Grid item xs={8} sx={{ p: 0.5 }}>
                    {"\u00A0"}
                  </Grid>
                </Grid>
                <Grid container sx={{ borderBottom: "1px solid #000" }}>
                  <Grid
                    item
                    xs={4}
                    sx={{ borderRight: "1px solid #000", p: 0.5 }}
                  >
                    Received for remittance through NEFT
                  </Grid>
                  <Grid item xs={8} sx={{ p: 0.5 }}>
                    {"\u00A0"}
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid
                    item
                    xs={4}
                    sx={{ borderRight: "1px solid #000", p: 0.5 }}
                  >
                    Date
                  </Grid>
                  <Grid item xs={8} sx={{ p: 0.5 }}>
                    {"\u00A0"}
                  </Grid>
                </Grid>
              </Box>

              <Box sx={{ border: "1px solid #000", borderTop: "none", p: 0.5 }}>
                ** The Remittance Facility to a Bank otherr then Nepal SBI Bank
                Ltd., will be operational after RBI's notification
              </Box>
            </Box>
          </Box>
        </form>
        {/* ✅ MOBILE PRINT PREVIEW MODAL */}
        <Modal
          open={showPrintPreview}
          onClose={() => {
            setShowPrintPreview(false);
            setPreviewPdfUrl(null);
          }}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              width: "95vw",
              height: "95vh",
              bgcolor: "background.paper",
              borderRadius: 2,
              boxShadow: 24,
              p: 2,
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* Header */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
                pb: 1,
                borderBottom: "2px solid #1976d2",
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: "bold", color: "#1976d2", fontSize: "1rem" }}>
                Challan Preview
              </Typography>
              <IconButton
                onClick={() => {
                  setShowPrintPreview(false);
                  setPreviewPdfUrl(null);
                }}
                sx={{
                  bgcolor: "#ffebee",
                  "&:hover": { bgcolor: "#ffcdd2" },
                }}
              >
                <Close />
              </IconButton>
            </Box>

            {/* PDF Preview */}
            <Box
              sx={{
                flex: 1,
                overflow: "auto",
                border: "1px solid #e0e0e0",
                borderRadius: 1,
                mb: 2,
                bgcolor: "#f5f5f5",
              }}
            >
              {previewPdfUrl && (
                <iframe
                  src={previewPdfUrl}
                  style={{
                    width: "100%",
                    height: "100%",
                    border: "none",
                  }}
                  title="Challan Preview"
                />
              )}
            </Box>

            {/* Action Buttons */}
            <Box sx={{ display: "flex", gap: 2 }}>
              {/* ✅ Download PDF Button (Primary Action) */}
              <Button
                variant="contained"
                fullWidth
                startIcon={<DownloadIcon />}
                onClick={() => {
                  if (previewPdfUrl) {
                    // Convert data URL to blob and download
                    fetch(previewPdfUrl)
                      .then(res => res.blob())
                      .then(blob => {
                        const link = document.createElement('a');
                        link.href = URL.createObjectURL(blob);
                        link.download = `NEFT_Challan_${paymentNumber || 'payment'}.pdf`;
                        link.click();
                        URL.revokeObjectURL(link.href);
                        toast.success("PDF downloaded successfully!");
                      });
                  }
                }}
                sx={{
                  height: 50,
                  bgcolor: "#1976d2",
                  fontSize: "0.9rem",
                  fontWeight: "bold",
                  "&:hover": { bgcolor: "#1565c0" },
                }}
              >
                Download PDF
              </Button>

              {/* ✅ Close Button */}
              <Button
                variant="outlined"
                fullWidth
                startIcon={<Close />}
                onClick={() => {
                  setShowPrintPreview(false);
                  setPreviewPdfUrl(null);
                }}
                sx={{
                  height: 50,
                  fontSize: "0.9rem",
                  fontWeight: "bold",
                  borderColor: "#d32f2f",
                  color: "#d32f2f",
                  "&:hover": {
                    borderColor: "#c62828",
                    bgcolor: "#ffebee",
                  },
                }}
              >
                Close
              </Button>
            </Box>

            {/* ✅ Info Text */}
            <Typography
              variant="caption"
              sx={{
                mt: 1,
                textAlign: "center",
                color: "#666",
                fontSize: "0.7rem",
              }}
            >
              💡 Download PDF and print from your device's PDF viewer
            </Typography>
          </Box>
        </Modal>
      </Box>
    </>
  );
};

export default NeftRtgsPaymentForm;